module.exports = __webpack_public_path__ + "static/img/p2.eed0501.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/p2.png
// module id = aP9H
// module chunks = 0